


























































import { Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
const numeral = require('numeral')

@Component
export default class LedgerAccounts extends Vue {
  private accountLogin = false
  // computed
  get wallet() {
    return vxm.transit.wallet
  }

  get ledgerAccounts() {
    return vxm.modals.ledgerAccounts
  }

  async loginAccount(account: string, auth: string) {
    this.accountLogin = true
    this.$bvModal.hide('modal-ledger')
    await this.wallet.login(account, auth)
    await vxm.user.getDappLiquid({ account: account, currentUser: true })
    await vxm.user.getDapphdlData({ account: account, currentUser: true })
    await vxm.user.getRefundTable({ account: account, currentUser: true })
    await vxm.user.getStakingTable({ account: account, currentUser: true })
  }

  resetModal() {
    vxm.modals.setLedgerModal({})
    if (!this.accountLogin) {
      vxm.alerts.setAlert({
        show: true,
        dismissible: true,
        title: 'Canceled by User!',
        message:
          'Account selection canceled by user. Login again to start over.',
        variant: 'danger',
        dismissSecs: 6,
        dismissCountDown: 6
      })
    }
    this.accountLogin = false
  }

  handleOk() {}

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
